import { TokenService } from '../services/auth/TokenService';
import logger from './logger';


export const TeacherIdManager = {
  /**
   * Get the current teacher ID from the most reliable source
   * @returns {number|null} Teacher ID or null if not available
   */
  getCurrentTeacherId: () => {
    try {
      const persistedId = TokenService.getTeacherId();
      if (persistedId) {
        return persistedId;
      }

      const userData = TokenService.getUserFromToken();
      if (userData?.teacherId) {
        TokenService.setTeacherId(userData.teacherId);
        return userData.teacherId;
      }

      logger.warn('No teacher ID available from token or localStorage');
      return null;
    } catch (error) {
      logger.error('Error getting teacher ID', error);
      return null;
    }
  },

  /**
   * Ensure teacher ID is properly stored in localStorage
   * @param {number} teacherId - Teacher ID to persist
   */
  ensurePersisted: (teacherId) => {
    try {
      if (teacherId && typeof teacherId === 'number') {
        TokenService.setTeacherId(teacherId);
        logger.debug('Teacher ID persisted to localStorage', { teacherId });
      }
    } catch (error) {
      logger.error('Error persisting teacher ID', error);
    }
  },

  /**
   * Validate that teacher ID is available and valid
   * @returns {boolean} True if valid teacher ID is available
   */
  isValid: () => {
    const teacherId = TeacherIdManager.getCurrentTeacherId();
    return !!(teacherId && typeof teacherId === 'number' && teacherId > 0);
  },

  /**
   * Clear teacher ID from localStorage (used during logout)
   */
  clear: () => {
    try {
      localStorage.removeItem(TokenService.TEACHER_ID_KEY);
      logger.debug('Teacher ID cleared from localStorage');
    } catch (error) {
      logger.error('Error clearing teacher ID', error);
    }
  }
};

export default TeacherIdManager;